
import { combineReducers } from "redux";
import AppReducer from './reducers/AppReducer'


const Root = combineReducers({
  App:AppReducer,
});

export default Root;
